var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Checkbox } from '@fluentui/react/lib/Checkbox';
import { ComboBox } from '@fluentui/react/lib/ComboBox';
import { DirectionalHint } from '@fluentui/react/lib/Callout';
import { Icon } from '@fluentui/react/lib/Icon';
import { Label } from '@fluentui/react/lib/Label';
import { PanelType } from '@fluentui/react/lib/Panel';
import { PropertyDataTypeEnum } from '../models/property-grid/data-type';
import { StandarPanel } from './StandarPanel';
import { TeachingBubble } from '@fluentui/react/lib/TeachingBubble';
import { TextField } from '@fluentui/react/lib/TextField';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import React from 'react';
import { ColorSelector } from './ColorSelector';
import { RoleComboBox } from '../../archivox';
import { Column, Row } from '..';
import { RoleManager } from '../../archivox/components/RoleManager';
import { isNullOrEmpty } from '../helpers/string-helper';
import { Grid } from './Grid';
import { CodeEditor } from './CodeEditor';
import { JavaScriptEditorPanel } from './JavaScriptEditorPanel';
import { SqlEditorPanel } from './SqlEditorPanel';
import { JsonEditorPanel } from './JsonEditorPanel';
import { XmlEditorPanel } from './XmlEditorPanel';
import { KeyWordField } from './KeyWordField';
export const helpIconTheme = {
    fontWeight: 'bold',
    color: '#0078d4',
    fontSize: '0.8em',
    border: 'solid 1px #0078d4',
    borderRadius: '50%',
    background: 'white',
    padding: '1px',
    marginLeft: '3px'
};
export class PropertyConfigurator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            controlType: props.controlType,
            helpText: props.helpText || '',
            label: props.label,
            language: props.language || 'javascript',
            options: props.options || [],
            prefix: props.suffix || '',
            roles: props.roles || [],
            series: props.series || [],
            showActionEditor: false,
            showAdvanceEditor: false,
            showRolePanel: false,
            showTeaching: false,
            subseries: props.subseries || [],
            tooltip: props.tooltip || '',
            value: props.value,
            showCustomForm: false,
            customFormValues: {}
        };
        this._emitOnChange = this._emitOnChange.bind(this);
    }
    componentWillReceiveProps(props) {
        this.setState({
            controlType: props.controlType,
            helpText: props.helpText || '',
            label: props.label,
            language: props.language || 'javascript',
            options: props.options || [],
            prefix: props.suffix || '',
            roles: props.roles || [],
            series: props.series || [],
            subseries: props.subseries || [],
            tooltip: props.tooltip,
            value: props.value
        });
    }
    _isHelpVisible() {
        return typeof this.props.onRenderHelp === 'function' || (this.state.helpText != null && this.state.helpText != '');
    }
    _renderLabel() {
        const isIconVisible = this._isHelpVisible();
        return React.createElement(Label, null,
            this.state.label,
            isIconVisible && React.createElement("small", { ref: e => {
                    if (e != null) {
                        this._ref = e;
                    }
                } },
                React.createElement(Icon, { style: helpIconTheme, iconName: 'Help', onClick: (ev) => {
                        ev.preventDefault();
                        ev.stopPropagation();
                        this.setState({
                            showTeaching: true
                        });
                    } })));
    }
    _renderRoleEditor() {
        return React.createElement(React.Fragment, null,
            React.createElement(TextField, { label: this.props.label, readOnly: true, placeholder: this.props.label, value: `${(this.state.value || []).length} roles authorized`, onRenderSuffix: () => React.createElement("div", { style: { minWidth: '25px', textAlign: 'center' }, onClick: () => {
                        this.setState({
                            showRolePanel: true
                        });
                    } }, "..."), onRenderPrefix: () => React.createElement("div", null, this.props.execution === 'server' ? 'Sv' : 'Js'), onRenderLabel: () => this._renderLabel() }),
            React.createElement(StandarPanel, { isOpen: this.state.showRolePanel, type: PanelType.medium, headerText: 'Roles autorizados', onAccept: () => {
                    this.setState({
                        showRolePanel: false
                    });
                }, onClose: () => {
                    this.setState({
                        showRolePanel: false
                    });
                }, onRender: () => React.createElement(Grid, null,
                    React.createElement(RoleManager, { onAddItem: (roleId) => __awaiter(this, void 0, void 0, function* () {
                            const value = this.state.value || [];
                            if (!value.includes(roleId)) {
                                value.push(roleId);
                                this.props.onChanged(value);
                            }
                        }), onRemoveItem: (roleId) => __awaiter(this, void 0, void 0, function* () {
                            let value = this.state.value || [];
                            if (value.includes(roleId)) {
                                value = value.filter(o => o != roleId);
                                this.props.onChanged(value);
                            }
                        }), associateRoles: this.state.value || [], roles: this.state.roles || [] })) }));
    }
    _renderRoleComboBox() {
        return React.createElement(RoleComboBox, { selectedKey: this.state.value || 0, roles: this.state.roles || [], onChanged: role => this.props.onChanged(role.IdRol), label: this.state.label });
    }
    _renderInlineJavascriptEditor() {
        return React.createElement(React.Fragment, null,
            React.createElement(Label, null, this.state.label),
            React.createElement(CodeEditor, { value: this.state.value, onChanged: (value) => this.props.onChanged(value), language: 'javascript', height: this.props.height, onMount: this.props.onMountCodeEditor }));
    }
    _renderInlineJsonEditor() {
        return React.createElement(React.Fragment, null,
            React.createElement(Label, null, this.state.label),
            React.createElement(CodeEditor, { value: this.state.value, onChanged: (value) => this.props.onChanged(value), language: 'json', height: this.props.height, onMount: this.props.onMountCodeEditor }));
    }
    _renderInlineXmlEditor() {
        return React.createElement(React.Fragment, null,
            React.createElement(Label, null, this.state.label),
            React.createElement(CodeEditor, { value: this.state.value, onChanged: (value) => this.props.onChanged(value), language: 'xml', height: this.props.height, onMount: this.props.onMountCodeEditor }));
    }
    _renderInlineSqlEditor() {
        return React.createElement(React.Fragment, null,
            React.createElement(Label, null, this.state.label),
            React.createElement(CodeEditor, { value: this.state.value, onChanged: (value) => this.props.onChanged(value), language: 'sql', height: this.props.height, onMount: this.props.onMountCodeEditor }));
    }
    _renderCustomForm() {
        const onChanged = (key, value) => {
            this.props.onChanged(Object.assign(Object.assign({}, (this.state.value || {})), { [key]: value }));
        };
        return React.createElement(React.Fragment, null,
            React.createElement(TextField, { label: this.props.label || '', placeholder: this.props.label || '', onChange: (_, value) => this.props.onChanged(value), maxLength: 16636, value: this.state.value, multiline: this.props.multiline || false, onRenderLabel: () => this._renderLabel(), autoComplete: 'off', disabled: this.props.disabled || false, onRenderSuffix: () => (React.createElement("div", { style: {
                        minWidth: '25px',
                        textAlign: 'center'
                    }, onClick: () => {
                        this.setState({
                            showCustomForm: true,
                            customFormValues: this.state.value || {}
                        });
                    } }, "...")) }),
            React.createElement(StandarPanel, { isOpen: this.state.showCustomForm, type: PanelType.medium, headerText: this.props.label || '', onAccept: () => {
                    this.props.onChanged(this.state.customFormValues);
                    this.setState({ showCustomForm: false });
                }, onClose: () => this.setState({ showCustomForm: false }), onRender: () => {
                    if (typeof this.props.onRenderCustomForm === 'function') {
                        return this.props.onRenderCustomForm(this.state.value, onChanged);
                    }
                    return undefined;
                } }));
    }
    render() {
        var _a, _b;
        const editor = this.state.language === 'javascript'
            ? React.createElement(JavaScriptEditorPanel, { show: this.state.showAdvanceEditor, code: this.state.value, onAccept: (value) => {
                    this.setState({
                        value
                    }, () => this.props.onChanged(value));
                }, onChange: (value) => {
                    this.setState({
                        value
                    }, () => this.props.onChanged(value));
                }, onClose: () => {
                    this.setState({
                        showAdvanceEditor: false
                    });
                }, title: this.state.label })
            : this.state.language === 'sql'
                ? React.createElement(SqlEditorPanel, { show: this.state.showAdvanceEditor, code: this.state.value, onAccept: (value) => {
                        this.setState({
                            value
                        }, () => this.props.onChanged(value));
                    }, onChange: (value) => {
                        this.setState({
                            value
                        }, () => this.props.onChanged(value));
                    }, onClose: () => {
                        this.setState({
                            showAdvanceEditor: false
                        });
                    }, title: this.state.label })
                : this.state.language === 'json'
                    ? React.createElement(JsonEditorPanel, { code: this.state.value, onAccept: (value) => this.setState({ value }, () => this.props.onChanged(value)), onChange: (value) => this.setState({ value }, () => this.props.onChanged(value)), onClose: () => this.setState({ showAdvanceEditor: false }), show: this.state.showAdvanceEditor, title: this.state.label, onValidationError: () => {
                            if (this.props.onError) {
                                this.props.onError('El json contiene errores');
                            }
                        } })
                    : this.state.language === 'xml'
                        ? React.createElement(XmlEditorPanel, { code: this.state.value, onAccept: (value) => this.setState({ value }, () => this.props.onChanged(value)), onChange: (value) => this.setState({ value }, () => this.props.onChanged(value)), onClose: () => this.setState({ showAdvanceEditor: false }), show: this.state.showAdvanceEditor, title: this.state.label, onValidationError: () => {
                                if (this.props.onError) {
                                    this.props.onError('El xml contiene errores');
                                }
                            } })
                        : null;
        const help = this._isHelpVisible()
            ? (typeof this.props.onRenderHelp === 'function'
                ? this.props.onRenderHelp()
                : this.props.helpText) : null;
        const actionEditor = this.props.controlType === PropertyDataTypeEnum.Action
            ? React.createElement(StandarPanel, { isOpen: this.state.showActionEditor, type: PanelType.large, headerText: this.state.label, onAccept: () => {
                }, onClose: () => {
                    this.setState({
                        showActionEditor: false
                    });
                }, onRender: () => React.createElement("div", null) })
            : null;
        let control;
        if (typeof this.props.onRenderControl === 'function') {
            control = this.props.onRenderControl();
        }
        else {
            switch (this.props.controlType) {
                case PropertyDataTypeEnum.Text:
                case PropertyDataTypeEnum.LargeText:
                    control = React.createElement(TextField, { label: this.props.label || '', placeholder: this.props.label || '', onChange: (_, value) => {
                            this.props.onChanged(value);
                        }, maxLength: 16636, value: this.state.value, prefix: isNullOrEmpty(this.state.prefix) ? void 0 : this.state.prefix, style: isNullOrEmpty(this.props.suffix) ? {} : { fontFamily: 'monospace', fontWeight: 'bold' }, multiline: this.props.multiline || false, onRenderLabel: () => this._renderLabel(), autoComplete: 'off', disabled: this.props.disabled || false });
                    break;
                case PropertyDataTypeEnum.Code:
                    control = React.createElement(TextField, { label: this.props.label, readOnly: true, placeholder: this.props.label, onChange: (_, value) => {
                            this.props.onChanged(value);
                        }, maxLength: 1024, value: this.state.value || '', onRenderSuffix: () => React.createElement("div", { style: {
                                minWidth: '25px',
                                textAlign: 'center'
                            }, onClick: () => {
                                if (typeof this.props.onOpenEventEditor === 'function') {
                                    this.props.onOpenEventEditor(this.state.label);
                                }
                                else {
                                    if (this.props.language === 'javascript' || this.props.language === 'xml') {
                                        this.setState({ showAdvanceEditor: true });
                                    }
                                    else {
                                        this.setState({ showAdvanceEditor: true });
                                    }
                                }
                            } }, "..."), onRenderPrefix: () => React.createElement("div", null, this.props.execution === 'server' ? 'Sv' : 'Js'), onRenderLabel: () => this._renderLabel() });
                    break;
                case PropertyDataTypeEnum.Boolean:
                    control = React.createElement("div", null,
                        React.createElement(Checkbox, { label: this.props.label, onChange: (_, value) => this.props.onChanged(value), checked: this.state.value || false, onRenderLabel: () => this._renderLabel() }));
                    break;
                case PropertyDataTypeEnum.BooleanWithRule:
                    control = React.createElement(TextField, { label: this.props.label, placeholder: this.props.label, onChange: (_, value) => {
                            var _a;
                            return this.props.onChanged({
                                text: value || '',
                                checked: ((_a = this.state.value) === null || _a === void 0 ? void 0 : _a.checked) || false
                            });
                        }, style: { fontFamily: 'monospace' }, maxLength: 1024, value: ((_a = this.state.value) === null || _a === void 0 ? void 0 : _a.text) || '', disabled: !((_b = this.state.value) === null || _b === void 0 ? void 0 : _b.checked) || false, onRenderPrefix: () => (React.createElement(Checkbox, { onChange: (_, checked) => {
                                var _a;
                                this.props.onChanged({
                                    text: ((_a = this.state.value) === null || _a === void 0 ? void 0 : _a.text) || '',
                                    checked
                                });
                            }, checked: this.state.value.checked || false })), onRenderLabel: () => this._renderLabel() });
                    break;
                case PropertyDataTypeEnum.Option:
                    control = React.createElement("div", null,
                        this._renderLabel(),
                        React.createElement(ComboBox, { selectedKey: this.state.value || 0, useComboBoxAsMenuWidth: true, options: this.state.options || [], onChange: (_, value) => this.props.onChanged(value.key), onRenderOption: this.props.onRenderOption, disabled: this.props.disabled || false }));
                    break;
                case PropertyDataTypeEnum.Action:
                    control = React.createElement(TextField, { label: this.props.label || '', placeholder: this.props.label || '', onChange: (_, value) => {
                            this.props.onChanged(value);
                        }, maxLength: 16636, value: this.state.value, prefix: 'Action', iconProps: { iconName: 'SetAction' }, style: { fontFamily: 'monospace', fontWeight: 'bold' }, onRenderLabel: () => this._renderLabel(), autoComplete: 'off', onRenderSuffix: () => React.createElement("div", { onClick: () => {
                                this.setState({
                                    showActionEditor: true
                                });
                            } }, "Editar") });
                    break;
                case PropertyDataTypeEnum.Role:
                    control = this._renderRoleEditor();
                    break;
                case PropertyDataTypeEnum.RoleComboBox:
                    control = this._renderRoleComboBox();
                    break;
                case PropertyDataTypeEnum.InlineJavaScriptEditor:
                    control = this._renderInlineJavascriptEditor();
                    break;
                case PropertyDataTypeEnum.InlineJsonEditor:
                    control = this._renderInlineJsonEditor();
                    break;
                case PropertyDataTypeEnum.InlineXmlEditor:
                    control = this._renderInlineXmlEditor();
                    break;
                case PropertyDataTypeEnum.InlineSqlEditor:
                    control = this._renderInlineSqlEditor();
                    break;
                case PropertyDataTypeEnum.CustomForm:
                    control = this._renderCustomForm();
                    break;
                case PropertyDataTypeEnum.Color:
                    control = React.createElement(ColorSelector, { label: this.props.label, value: this.state.value || '', onChanged: value => this.props.onChanged(value) });
                    break;
                case PropertyDataTypeEnum.Keywords:
                    control = React.createElement(KeyWordField, { label: this.props.label, keywords: (this.state.value || '').split('|'), selectedItems: (this.state.value || '').split('|'), onChanged: value => this.props.onChanged(value) });
                    break;
                case PropertyDataTypeEnum.Rule:
                    control = React.createElement(TextField, { label: this.props.label, placeholder: this.props.label, onChange: (_, value) => this.props.onChanged(value), maxLength: 1024, value: this.state.value || '', onRenderPrefix: () => React.createElement("span", null, "Fx"), onRenderLabel: () => this._renderLabel() });
                    break;
                default:
                    control = React.createElement("div", null, "Campo no soportado");
                    break;
            }
        }
        const column = React.createElement(Column, { size: this.props.colSize || 12 },
            isNullOrEmpty(this.state.tooltip)
                ? control
                : React.createElement(TooltipHost, { content: this.state.tooltip, directionalHint: DirectionalHint.leftCenter }, control),
            editor,
            help != null && this.state.showTeaching && React.createElement(TeachingBubble, { secondaryButtonProps: {
                    children: 'Cerrar',
                    onClick: () => this.setState({ showTeaching: false })
                }, onDismiss: () => this.setState({ showTeaching: false }), headline: this.state.label, targetElement: this._ref }, help),
            actionEditor);
        const isColumn = this.props.gridColumn === true;
        if (isColumn) {
            return column;
        }
        else {
            return React.createElement(Row, null, column);
        }
    }
    _emitOnChange() {
    }
}
